//WE.Flow.Html.Models.AuthorizedUser

export class AuthorizedUser {
    name: string = "";
    role: string = "";
}
